import { SubpageBanner } from './SubpageBanner';

/**
 * Alt sayfa iskeleti: SubpageBanner + içerik alanı (container).
 * @param {{
 *   title: string,
 *   subtitle?: string,
 *   bannerEyebrow?: string,
 *   children?: unknown,
 *   contentClassName?: string,
 * }} props
 */
export function SubpageLayout({
    title,
    subtitle,
    bannerEyebrow,
    children,
    contentClassName = '',
}) {
    return (
        <>
            <SubpageBanner
                title={title}
                subtitle={subtitle}
                eyebrow={bannerEyebrow}
            />
            <div
                className={`subpage-body ${contentClassName}`.trim()}
            >
                <div className="container py-5">{children}</div>
            </div>
        </>
    );
}
